import React, { useEffect, useState } from 'react';
import { Select } from 'tea-component';
import { useIntl } from 'umi';

export default function FollowingGroup(props: any) {
  const { value: defaultValue, onConfirm, options = [] } = props;
  const [value, setValue] = useState(defaultValue);
  const { formatMessage } = useIntl();
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <Select
      className="select-item select-item-l"
      appearance="button"
      options={options}
      size='l'
      value={value}
      listHeight={235}
      matchButtonWidth
      onChange={(value) => {
        setValue(value);
        if (onConfirm instanceof Function) {
          onConfirm(value);
        }
      }}
      button={(option) => (
        <div className="dbi-select-button">
          <div className="select-button-text">
            {formatMessage({
              id: `dbi_top_following_group`,
            })}
          </div>
          <span className="select-button-desc">
            {
              options?.filter((e: any) => {
                return e?.value == value;
              })[0]?.text
            }
          </span>
        </div>
      )}
    />
  );
}
